import { Keyboard } from 'react-native';
import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  KeyboardAvoiding,
  useSafeArea,
  useScreenSize,
} from '@banhala/ui-kit';
import { isIOS, isWeb } from 'shared/src/utils';
import { useCreateFolder } from '../../../queries/useCreateFolder';
import { FolderNameEditor } from '../components/FolderNameEditor';

export const useCreateFolderBottomSheet = createUseBottomSheetModal<
  { folderSno: number; folderName: string },
  void
>(({ confirm, cancel }) => {
  const { mutateAsync: createFolder } = useCreateFolder();
  const { bottom, top } = useSafeArea();
  const { height: screenHeight } = useScreenSize();

  const sheet = (
    <BottomSheetContainer
      onPressClose={() => {
        Keyboard.dismiss();
        cancel();
      }}
      minHeight={isIOS ? (screenHeight - bottom - top) / 3 : 0}
      title="새 서랍 추가"
    >
      <FolderNameEditor
        initialValue=""
        validate={value => value.length > 0}
        onSubmit={async value => {
          const {
            data: { sno },
          } = await createFolder({ title: value });
          confirm({ folderSno: sno, folderName: value });
        }}
        onClose={cancel}
      />
    </BottomSheetContainer>
  );

  // 웹은 KeyboardAvoiding이 no-op(behavior=undefined)이면서 visualViewport 차이만큼
  // 하단에 여백을 만들어 시트가 화면 끝까지 안 닿음 → 웹에서는 래핑하지 않음.
  return isWeb ? sheet : <KeyboardAvoiding>{sheet}</KeyboardAvoiding>;
});
